module.exports = __webpack_public_path__ + "img/steel-bits.2934d2bb.png";